import { faUserPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as ActivityItem from 'assets/js/pages/contacts/single/timeline/timeline-list/item/items/ActivityItem';

type ItemWithResource = { resource: { name: string } };

interface Props<T extends ItemWithResource> {
    item: T;
}

const SignupFormSubmitted = <T extends ItemWithResource>({ item }: Props<T>) => {
    const { resource } = item;
    return (
        <ActivityItem.Root>
            <ActivityItem.Trigger disabled>
                <ActivityItem.Icon>
                    <FontAwesomeIcon icon={faUserPlus} />
                </ActivityItem.Icon>
                <p>
                    Signup for updates using the form <b>{resource.name}</b>
                </p>
            </ActivityItem.Trigger>
        </ActivityItem.Root>
    );
};

export default SignupFormSubmitted;
